// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Card that exposes a button to open the purchase order audit log in a
 * drawer. The audit events load lazily when the drawer is opened.
 */
import { HistoryOutlined } from '@/constants/hardfin-standard-icons';
import { useDisclosure } from '@/hooks/use-disclosure';
import { PurchaseOrderAuditDrawer } from '@/purchase-order/components/purchase-order-audit-drawer';
import { Button, Paper } from '@mui/material';

interface Props {
  purchaseOrderKey: string;
}

export function PurchaseOrderAuditCard(props: Props) {
  const drawer = useDisclosure();

  return (
    <Paper variant="outlined" sx={{ padding: 2 }}>
      <Button
        fullWidth
        size="small"
        startIcon={<HistoryOutlined />}
        onClick={drawer.open}
      >
        View audit log
      </Button>
      <PurchaseOrderAuditDrawer
        purchaseOrderKey={props.purchaseOrderKey}
        disclosure={drawer}
      />
    </Paper>
  );
}
